module.exports = __webpack_public_path__ + "static/media/3.7af4778c.JPG";